import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from 'next/link'

interface GuideCardData {
  title: string
  subtitle?: string;
  description?: string;
  hname?: string;
  href?: string;
  url?: string; // Optional video URL
  category?: string;
}

interface GuideCardProps {
  data: GuideCardData;
}

export default function GuideCard({ data }: GuideCardProps) {
  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography variant="h5" component="div">
          {data.title}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {data.subtitle}
        </Typography>
        <Typography variant="body2">
          {data.description}
        </Typography>
        {data.url && (
          <CardMedia
            component="iframe"
            height="750"
            src={data.url}
            title={data.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}
      </CardContent>
      {data.href ? (
      <CardActions>        
          <Link href={data.href}>
            <Button size="small">{data.hname}</Button>
          </Link>
      </CardActions>
      ) : null}
    </Card>
  );
}